import { render, staticRenderFns } from "./ServePlan.vue?vue&type=template&id=7150c3b9&scoped=true&"
import script from "./ServePlan.vue?vue&type=script&lang=js&"
export * from "./ServePlan.vue?vue&type=script&lang=js&"
import style0 from "./ServePlan.vue?vue&type=style&index=0&id=7150c3b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7150c3b9",
  null
  
)

export default component.exports